export default "__VITE_ASSET__GExz_SUW__"